import ChatIcon from '@mui/icons-material/Chat'
import { Badge, Button, IconButton } from '@mui/material'
import React, { FC, useContext, useState } from 'react'

import { TwilioConversationsContext } from '../../providers'
import { ChatUIWrapper } from './ChatUIWrapper'
import { RepairOrderChatDialog } from './RepairOrderChatDialog'
import { useChat } from './useChat'

interface Props {
  repairOrderId: string
  repairOrderNumber: number
  containerRef: React.RefObject<HTMLDivElement>
  isButton?: boolean
}

export const ChatBox: FC<Props> = ({
  repairOrderId,
  repairOrderNumber,
  containerRef,
  isButton
}) => {
  const { conversationUniqueNamesWithUnreadMessages } = useContext(
    TwilioConversationsContext
  )
  const [dialogOpen, setDialogOpen] = useState(false)
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)

  const { messages } = useChat(repairOrderId)

  return (
    <>
      {isButton ? (
        <Button
          variant="outlined"
          onClick={(event) => {
            setAnchorEl(event.currentTarget)
            setDialogOpen(!dialogOpen)
          }}>
          Chat
        </Button>
      ) : (
        <IconButton
          data-testid="ChatButton"
          onClick={(event) => {
            setAnchorEl(event.currentTarget)
            setDialogOpen(!dialogOpen)
          }}>
          <Badge
            showZero
            color={
              conversationUniqueNamesWithUnreadMessages.includes(repairOrderId)
                ? 'error'
                : 'primary'
            }
            sx={{
              '& .MuiBadge-badge': {
                bgcolor:
                  conversationUniqueNamesWithUnreadMessages.includes(
                    repairOrderId
                  ) && !dialogOpen
                    ? 'error'
                    : 'grey'
              }
            }}
            badgeContent={messages.length}>
            <ChatIcon color={dialogOpen ? 'disabled' : 'action'} />
          </Badge>
        </IconButton>
      )}
      <ChatUIWrapper {...{ anchorEl, containerRef, dialogOpen, setDialogOpen }}>
        <RepairOrderChatDialog
          {...{
            repairOrderId,
            repairOrderNumber,
            dialogOpen,
            setDialogOpen
          }}
        />
      </ChatUIWrapper>
    </>
  )
}
